module.exports = __webpack_public_path__ + "static/media/breakingBadImg.74e364fb.png";